import Console from './Console';

export const sendAdobePostMessage = (event, data) => {
  if (!window.uxpHost) {
    Console.error('UXP Environment not found');
  } else {
    window.uxpHost.postMessage({ event, data });
  }
};

export const getAdobeAuthToken = () => new Promise((resolve) => {
  const handleMessage = (event) => {
    const { name } = event.data;
    const { token } = event.data;

    if (name === 'get-token') {
      resolve(token);
      window.removeEventListener('message', handleMessage);
    }
  };

  window.addEventListener('message', handleMessage);

  sendAdobePostMessage('get-token', { key: 'adobe-auth-token' });
});

export const getActiveDocumentInfo = () => new Promise((resolve) => {
  const handleMessage = (event) => {
    const { name } = event.data;
    const { uuid } = event.data;
    const { extension } = event.data;

    if (name === 'get-active-document-info') {
      resolve({ uuid, extension });
      window.removeEventListener('message', handleMessage);
    }
  };

  window.addEventListener('message', handleMessage);

  sendAdobePostMessage('get-active-document-info');
});
